import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { BuyButton } from 'page/catalog/buttons/BuyButton'
import { ComboButton } from 'page/catalog/buttons/ComboButton'
import { ComboTextButton } from 'page/catalog/buttons/ComboTextButton'
import { TryButton } from 'page/catalog/buttons/TryButton'
import { ItemActionsBaga } from 'page/catalog/ItemCard/ItemActionsBaga'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { ui } from 'store/home/ui/HomeUiStore'
import { opt } from 'store/opt'
import { Item } from 'type/Item'
import css from './ItemActions.module.scss'

type Props = {
  item: Item
}

export const ItemActions = observer(({ item }: Props) => {
  const demo = useDemo()
  const { mobile } = ui.window
  const buy = demo.isBuyButtonVisible(item, false)
  const try_on = demo.canTry(item)
  const combine = demo.canCombine(item)

  if (opt.baga) return <ItemActionsBaga item={item} />

  if (mobile && !buy && !try_on) return null

  if (mobile) return (
    <Vertical gap={8}>
      {buy && <BuyButton item={item} />}
      {try_on && <TryButton className={css.button} item={item} />}
    </Vertical>
  )

  if (!buy && !try_on && !combine) return null

  return (
    <Space gap={8} wrap>
      {buy && <BuyButton className={css.button} item={item} />}
      {(try_on || combine) && <Space className={css.space} gap={8} wide wrap>
        {try_on && <TryButton className={css.button} item={item} />}
        {combine ? try_on ? <ComboButton item={item} /> : <ComboTextButton item={item} /> : null}
      </Space>}
    </Space>
  )
})
